export const NON_CYCLIC_FREQUENCY_IDS = new Set<number>([13, 11, 12, 14]);

export interface FrequencyItem {
  idFrequency: number;
  frequencyName: string;
  frequencyValue: number; 
}

export function calculateTotalDose24h(
  quantity: string | number | null | undefined,
  idFrequency: number | null | undefined,
  frequencyList: FrequencyItem[]
): { total: number; label: string } | null {
  if (quantity === null || quantity === undefined || quantity === '') return null;
  if (!idFrequency) return null;

  const numericQuantity = typeof quantity === 'string'
    ? parseFloat(quantity.replace(',', '.'))
    : quantity;

  if (isNaN(numericQuantity) || numericQuantity <= 0) return null;

  const frequencyItem = frequencyList.find(f => f.idFrequency === idFrequency);
  if (!frequencyItem) return null;

  if (NON_CYCLIC_FREQUENCY_IDS.has(idFrequency)) {
    return {
      total: numericQuantity,
      label: formatDose(numericQuantity),
    };
  }

  const freqValue = frequencyItem.frequencyValue;
  if (!freqValue || freqValue <= 0) return null;

  const administrations = 24 / freqValue;
  const total = administrations * numericQuantity;

  return {
    total: total,
    label: formatDose(total),
  };
}

function formatDose(value: number): string {
  return parseFloat(value.toFixed(4)).toString().replace('.', ',');
}